import { Auth0Provider } from '@auth0/auth0-react';
import { ReactNode } from 'react';

/**
 * Same Auth0 application as the hotel console — the two InnPro web apps are one single sign-on.
 * Only the callback URL differs (resto.innpro.in), and it must be registered in the Auth0 tenant.
 */
export function Auth0ProviderWithNavigate({ children }: { children: ReactNode }) {
    const domain = process.env.REACT_APP_AUTH0_DOMAIN;
    const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
    const redirectUri = process.env.REACT_APP_AUTH0_CALLBACK_URL;

    if (!(domain && clientId && redirectUri)) {
        return null;
    }

    return (
        <Auth0Provider
            domain={domain}
            clientId={clientId}
            cacheLocation="localstorage"
            authorizationParams={{ redirect_uri: redirectUri, scope: 'openid profile email' }}
        >
            {children}
        </Auth0Provider>
    );
}
